module.exports = __webpack_public_path__ + "img/intro5.78742487.png";